<template>
    <div class="nof">
        <span>404错误页面</span>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.nof {
    width: 100%;
    font-size: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
